import React, { useContext } from 'react';
import resizeImage from '../../../../../utils/resizeImage';
import { Context } from '../../../../../context/AppContext';
import PackageIcon from '../../../../../assets/packageIcon';
import PlaceholderLogo from '../../../../../assets/placeholderLogo.png';
import LazyLoad from '../../../../../components/LazyLoad';
import './styles.css';

const Logo = ({
  logo,
  name,
  cardLayout: { type, ...cardLayout },
  listingId,
}) => {
  const { webp } = useContext(Context);

  return (
    <div className="Listview__Card__logoWrapper">
      <LazyLoad>
        <div className="Listview__Card__logo">
          <img
            src={
              logo
                ? resizeImage(logo, {
                    width: 300,
                    height: 300,
                    webp,
                    quality: 40,
                  })
                : PlaceholderLogo
            }
            alt={name}
          />
        </div>
      </LazyLoad>

      {cardLayout && cardLayout.name && type !== 'bronzeFree' ? (
        <div className="Listview__Card__packageType">
          {type !== 'bronzeBasic' ? (
            <PackageIcon
              gradientFill1={cardLayout.gradientFill1}
              gradientFill2={cardLayout.gradientFill2}
              fill={cardLayout.color}
              id={listingId}
            />
          ) : null}

          <span>
            {cardLayout.name}{' '}
            {type === 'bronzePlus' ? (
              <span className="Listview__Card__subText">+</span>
            ) : null}
          </span>
        </div>
      ) : null}
    </div>
  );
};
export default Logo;
